import { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

import { openWebView, logCardClick } from '../../utils/NativeWebView';
import { opentItent } from '../../utils/ObChat';
import { cardInOut } from '../../animations/PageAnimations';
import { useAppDispatch } from '../../hooks';
import { openMsgModal } from '../../store/MessageModalSlice';
import type { ICard } from '../../types';

import IconArrowNext from '../IconArrowNext';
import IconPlus from '../IconPlus';

import './Card.scss';

const Card = ({ id, index, title, description, image, type, link = '', textClose, messageData, disclosure }: ICard) => {

  // const srcImage = `${process.env.PUBLIC_URL}/images/${image}`;
  const [showBack, setShowBack] = useState(false);

  const dispatch = useAppDispatch();

  const navigate = useNavigate();
  const handleClick = () => {
    logCardClick(id, title, type, link);

    switch (type) {
      case 'link':
        navigate(link);
        break;
      case 'web':
        openWebView(link, textClose);
        break;
      case 'qr':
        setShowBack(!showBack);
        break;
      case 'chatbot':
        opentItent(link);
        break;
      case 'message':
        messageData && dispatch(openMsgModal(messageData));
        break;
    }
  };

  return (
    <motion.div
      key={id}
      custom={index}
      initial="initial"
      animate="animate"
      exit="exit"
      variants={cardInOut}
      onClick={handleClick}
      className="card-outer"
      whileTap={{ scale: 0.95 }}
    >
      <motion.div className={`card-container ${showBack && 'showBack'}`}>

        <div className="card">
          <div className="card-image">
            {image && <img className="select-none" src={image} alt="" />}
          </div>
          <div className="card-text">
            <h2>{title}</h2>
            <p className="leading-tight text-sm xl:text-lg xl:leading-tight pr-4">{description}</p>
            {disclosure && <p className="text-xs mt-5 pr-8 -mb-4">{disclosure}</p>}
          </div>
          <div className="absolute bottom-5 right-5 bg-gray p-1 flex items-center justify-center border rounded-full">
            {type === 'qr' ? <IconPlus /> : <IconArrowNext /> }
          </div>
        </div>

        {/* QR BACK */}
        { type === 'qr' && <div className="card back">
          <div className="w-full flex flex-col items-center justify-center">
            <div className=" mx-2 w-full py-2 text-center">
              <h2 className="text-2xl leading-tight">{title}</h2>
              <p className="text-lg leading-tight pr-0">Escanea el código QR</p>
            </div>
            <img className="select-none bg-white" src={`${process.env.PUBLIC_URL}/images/qr.png`} alt="" />
            <IconPlus />
          </div>
        </div> }

      </motion.div>
    </motion.div>
  );
};
export default Card;

